import Helmet from 'react-helmet';
import Favicon from 'react-favicon';

import {connects} from '@gisatcz/ptr-state';
import Action from './state/Action';
import config from './config';

// base styles need to be imported before all components
import '@gisatcz/ptr-core/lib/styles/reset.css';
import '@gisatcz/ptr-core/lib/styles/base.scss';
import './styles/index.scss';

import {AppContainer} from '@gisatcz/ptr-components';

import {create as createRouter} from '@gisatcz/ptr-router';
import {init as initCore} from './core';
import App from './components/App';
import favicon from './assets/favicon.ico';

import configurationData from './data/configuration';
import view from './data/view';

const path = process.env.PUBLIC_URL;

function createRoutes() {
	return {
		'': {
			name: 'homepage',
			handler: function () {},
		},
	};
}

function init(Store, {absPath, isPreloaded, currentUrl, navHandler}) {
	/**
	 * Creates router instance that can be used to manipulat urls.
	 *
	 * App handler updates store with current page and it's up to views to react to the change.
	 * In case of url change, redux selector possibly retrieves different data and passes them
	 * into some the component.
	 *
	 */

	const router = createRouter({
		rootUrl: absPath,
		currentUrl,
		routes: createRoutes(Store),
		navHandler,
	});

	initCore({router});

	if (isPreloaded) {
		return;
	}

	Store.dispatch(Action.app.updateLocalConfiguration(config));
	Store.dispatch(Action.app.setKey('emsn091Manila'));
	Store.dispatch(Action.app.setBaseUrl(path));

	/* Add configuration */
	Store.dispatch(Action.app.setLocalConfiguration('data', configurationData));

	/* Intit insar app */
	Store.dispatch(Action.insar.initApp(view));
}

const ConnectedAppContainer = connects.AppContainer(AppContainer);

const AppComponent = () => {
	return (
		<>
			<Favicon url={favicon} />
			<Helmet defaultTitle="EMSN 091 Manila" />
			<ConnectedAppContainer appKey="emsn091Manila" dark>
				<App />
			</ConnectedAppContainer>
		</>
	);
};

export {AppComponent as App, init};
